"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bnMin = exports.bnMax = exports.ifNanThen = exports.MAX_UINT256 = exports.isNaN = exports.truncateDecimals = exports.hexToDec = exports.toHex = exports.toBNFixed = exports.toNumber = exports.truncate = exports.localiseNumber = exports.areNumbers = exports.isNumberAndNonZero = exports.isNumber = exports.BN = exports.BigNumber = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var BigNumber = function (arg, base) {
    return new bignumber_js_1.default(arg, base);
};
exports.BigNumber = BigNumber;
exports.BN = exports.BigNumber;
var isNumber = function (num) { return !exports.BigNumber(num).isNaN(); };
exports.isNumber = isNumber;
var isNumberAndNonZero = function (n) {
    var num = exports.BigNumber(n);
    return !num.isNaN() && !num.isZero();
};
exports.isNumberAndNonZero = isNumberAndNonZero;
var areNumbers = function (numbers) {
    return numbers.every(exports.isNumber);
};
exports.areNumbers = areNumbers;
var localiseNumber = function (num) {
    return exports.BigNumber(num).toNumber().toLocaleString("en-US");
};
exports.localiseNumber = localiseNumber;
var truncate = function (num) {
    return Math.trunc(exports.BigNumber(num).toNumber()).toString(10);
};
exports.truncate = truncate;
var toNumber = function (num) { return exports.BigNumber(num).toNumber(); };
exports.toNumber = toNumber;
var toBNFixed = function (num) { return exports.BigNumber(num).toFixed(); };
exports.toBNFixed = toBNFixed;
var toHex = function (num) {
    return "0x" + exports.BigNumber(num).toString(16);
};
exports.toHex = toHex;
var hexToDec = function (hex) { return parseInt(hex, 16); };
exports.hexToDec = hexToDec;
var truncateDecimals = function (num, decimalPlaces) {
    if (decimalPlaces === void 0) { decimalPlaces = 18; }
    if (typeof num === "string" && /\.(0{0,})?$/.test(num))
        return num;
    return exports.BigNumber(num).decimalPlaces(decimalPlaces).toFixed();
};
exports.truncateDecimals = truncateDecimals;
var isNaN = function (num) {
    return exports.BigNumber(num).isNaN();
};
exports.isNaN = isNaN;
exports.MAX_UINT256 = exports.BN(Math.pow(2, 256)).toFixed();
var ifNanThen = function (num, defValue) {
    if (exports.isNaN(defValue)) {
        throw new Error("Ensure defValue is a Number");
    }
    return exports.isNaN(num) ? defValue : num;
};
exports.ifNanThen = ifNanThen;
var bnMax = function () {
    var nums = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nums[_i] = arguments[_i];
    }
    return bignumber_js_1.default.maximum.apply(bignumber_js_1.default, nums);
};
exports.bnMax = bnMax;
var bnMin = function () {
    var nums = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nums[_i] = arguments[_i];
    }
    return bignumber_js_1.default.minimum.apply(bignumber_js_1.default, nums);
};
exports.bnMin = bnMin;
